(function () {
  var drawer = document.getElementById('vayl-cart-drawer');
  var overlay = document.getElementById('vayl-cart-overlay');
  var closeBtn = document.getElementById('vayl-cart-close');
  var cartToggle = document.getElementById('vayl-cart-toggle');
  var itemsEl = document.getElementById('vayl-cart-items');
  var subtotalEl = document.getElementById('vayl-cart-subtotal');

  if (!drawer || !overlay || !itemsEl) return;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openDrawer() {
    drawer.style.transform = 'translateX(0)';
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'auto';
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.style.transform = 'translateX(100%)';
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    document.querySelectorAll('.vayl-cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p style="color:#9A978D;padding:20px 0;">Your cart is empty.</p>';
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (item) {
      var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div style="font-size:12px;color:#9A978D;margin-top:2px;">' + item.variant_title + '</div>'
        : '';
      return '' +
        '<div style="display:flex;gap:14px;padding:18px 0;border-bottom:1px solid rgba(255,255,255,.08);align-items:center;">' +
          '<div style="width:64px;height:64px;background:#fff;flex-shrink:0;overflow:hidden;">' +
            (item.image ? '<img src="' + item.image + '" style="width:100%;height:100%;object-fit:cover;">' : '') +
          '</div>' +
          '<div style="flex:1;">' +
            '<div style="font-size:14px;font-weight:600;">' + item.product_title + '</div>' +
            variantLine +
            '<div style="display:flex;align-items:center;gap:10px;margin-top:10px;">' +
              '<button type="button" class="vayl-qty-btn" data-key="' + item.key + '" data-delta="-1" style="width:24px;height:24px;background:#26272B;color:#EDEAE3;border:1px solid rgba(255,255,255,.16);cursor:pointer;border-radius:4px;">−</button>' +
              '<span style="min-width:16px;text-align:center;font-size:13px;">' + item.quantity + '</span>' +
              '<button type="button" class="vayl-qty-btn" data-key="' + item.key + '" data-delta="1" style="width:24px;height:24px;background:#26272B;color:#EDEAE3;border:1px solid rgba(255,255,255,.16);cursor:pointer;border-radius:4px;">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="font-size:14px;font-weight:600;">' + money(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeQty(key, delta) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      var newQty = Math.max(0, item.quantity + delta);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      }).then(function (r) { return r.json(); }).then(renderCart);
    });
  }

  itemsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('.vayl-qty-btn');
    if (!btn) return;
    changeQty(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-delta'), 10));
  });

  if (cartToggle) {
    cartToggle.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart();
      openDrawer();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('.vayl-cart-form')) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(openDrawer)
      .catch(function () { form.submit(); });
  });

  fetchCart();
})();
